import { render, staticRenderFns } from "./IndustryLogPanel.vue?vue&type=template&id=379ef413"
import script from "./IndustryLogPanel.vue?vue&type=script&lang=js"
export * from "./IndustryLogPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports